import { render, staticRenderFns } from "./ChooseEditor.vue?vue&type=template&id=96c54f3a&"
import script from "./ChooseEditor.vue?vue&type=script&lang=js&"
export * from "./ChooseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports